module.exports = __webpack_public_path__ + "static/assets/d34dbc2d88a3e8dc9d81770eb9145b08.png";